

import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import '../../ContentManagement/Home/Modal/BannerinputGetModal.css'// Import external CSS
import { MdCancel } from "react-icons/md";

import registration_complete_gif from "../../../Assets/registration_successful_gif.gif"

const RegistrationCompleteModal = ({ open, onClose, setSubmittedValues, submittedValues, modalHeadingName,handleNextModal}) => {
    // const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [selectedDocumentType, setSelectedDocumentType] = React.useState('');


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                // maxWidth: "700px",
                // margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={onClose}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">

                        <Box>
                            <Typography className="custom-title-text" color='white'>
                                {/* {modalHeadingName} */}
                                Registration Successful
                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>


                <DialogContent dividers>
                    <Grid container  textAlign="center" sx={{padding:{xs:0,md:2}}}>

                        <Grid item xs={12} md={12}>
                            <Typography variant='h1'  sx={{fontSize:{xs:"20px",md:"30px"}}}>Registration Complete</Typography>
                            <Typography variant='body1' sx={{maxWidth:"600px",margin:"auto",mt:1,color:"gray"}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it</Typography>
                            <Box
                                component="img"
                                src={registration_complete_gif}

                            />


                            <Typography variant='body2'>
                                Do you want to purchase gold schemes?
                            </Typography>
                            <Grid sx={{ display: "flex", justifyContent: 'center', mt: 4}}>
                                <Grid>
                                    <Button

                                        onClick={onClose}
                                      
                                        variant="text"
                                        // className="custom-clear-button"
                                        sx={{
                                            // backgroundColor: "#C38F51",
                                            textTransform: "none",
                                            color: "white",
                                            fontSize: "16px",
                                            mr: "10px",
                                            // padding: "0px 40px",
                                            padding: { xs: "0px 20px", md: "0px 40px" },

                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "white",
                                            boxShadow: "none",
                                            color: "black",
                                            border: "1px solid black",
                                            "&:hover": {
                                                backgroundColor: "#3B4056",
                                                color: "white"
                                            },
                                        }}
                                    >
                                       No
                                    </Button>
                                    <Button
                                    onClick={handleNextModal}
                                        type="submit"
                                        variant="contained"
                                        // className="custom-ok-button"
                                        sx={{
                                            // backgroundColor: "#C38F51",
                                            textTransform: "none",
                                            color: "white",
                                            fontSize: "16px",
                                            boxShadow: "none",

                                            // padding: "0px 40px",
                                            padding: { xs: "0px 20px", md: "0px 40px" },

                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "#C38F51 0% 0% no-repeat padding-box",
                                            "&:hover": {
                                                backgroundColor: "#3B4056",
                                                boxShadow: "none",

                                            },
                                        }}
                                    >
                                        Yes
                                    </Button>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                </DialogContent>


            </Box >

        </Dialog >
    );
};

export default RegistrationCompleteModal;
